import { render } from "./gamePieChart.vue?vue&type=template&id=17e46850&scoped=true"
import script from "./gamePieChart.vue?vue&type=script&lang=js"
export * from "./gamePieChart.vue?vue&type=script&lang=js"

import "./gamePieChart.vue?vue&type=style&index=0&id=17e46850&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e46850"]])

export default __exports__